import type { StudentPayload } from "@/components/report/reportTypes";
import type { PersistedRun } from "@/features/assessment-v2/persistedSnapshot";
import { topArchetypes } from "@/features/assessment-v2/results";
import { buildRoadmap } from "@/features/roadmap/roadmaps";
import type { ArchetypeVector } from "@/features/assessment-v2/archetypes";

export function snapshotReport(payload: StudentPayload, run: PersistedRun | null): StudentPayload {
  const tally = run?.state.part2?.archetype_tally as ArchetypeVector | undefined;
  const primary = tally && Object.values(tally).some(v => Number(v) > 0) ? topArchetypes(tally).primary : null;
  return {
    ...payload,
    presentation_snapshot: {
      template_version: "living-report-v2",
      roadmaps: primary && run?.state.band
        ? [buildRoadmap("journey", primary, run.state.band), buildRoadmap("learning", primary, run.state.band)]
        : payload.presentation_snapshot?.roadmaps ?? [],
    },
  };
}